


































































import Vue from "vue";
import axios from 'axios';

import VariableInput from "@/components/util/VariableInput.vue";
import SelectBox from "@/components/util/SelectBox.vue";
import FooterSimple from "@/parts/common/FooterSimple.vue";
import {
  CorporateIdRegExp,
  CorporateConstraintMessage,
  corporateRepresentativeRegExp,
  corporateRepresentativeLengthLimit,
  corporateRepresentativeConstraintErrorMessage,
  corporateRepresentativeKanaRegExp,
  corporateRepresentativeKanaLengthLimit,
  corporateRepresentativeKanaConstraintErrorMessage,
  corporateNameRegExp,
  corporateNameLengthLimit,
  corporateNameConstraintErrorMessage,
  corporateNameKanaRegExp,
  corporateNameKanaLengthLimit,
  corporateNameKanaConstraintErrorMessage,
  divisionNameRegExp,
  divisionNameLengthLimit,
  divisionNameConstraintErrorMessage,
  mailAddressRegExp,
  mailAddressLengthLimit,
  mailAddressConstraintErrorMessage,
  authPhoneNumberRegExp,
  authPhoneNumberLengthLimit,
  authPhoneNumberConstraintErrorMessage,
  faxRegExp,
  faxLengthLimit,
  faxConstraintErrorMessage,
} from "./constraint";

import { createCorpInfo  } from '@/api/CorpInfo';
import { CorpInfo, CreateCorpInfoRequest } from "@/api/dto/CorpInfo";
import { ErrorResponse } from '@/api/dto/Error';

interface CorpInfoForm {
  corporateId: string;
  managementUserId: string;
  corporateName: string;
  corporateNameKana: string;
  divisionName: string;
  corporateRepresentative: string;
  corporateRepresentativeKana: string;
  contactMailAddress: string;
  phoneNumber: string;
  fax: string;
}

export default Vue.extend({
  name: "CorpInformationForm",
  props: {
    confirm: {
      type: Boolean,
      default: false,
    },
    readInitData: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    VariableInput,
    SelectBox,
    FooterSimple,
  },
  created() {
    this.readData = this.readInitData;

    // 区分用項目
    this.division = 1;

    if (this.confirm) {
      this.readData = true;
    }

    this.initData();
  },
  watch: {
    "corpInfoForm.corporateId"(corporateId: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["corporateId"].error =
      CorporateIdRegExp.test(corporateId) ? "" : CorporateConstraintMessage;
      this.afterWatch();
    },
    "corpInfoForm.corporateRepresentative"(corporateRepresentative: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["corporateRepresentative"].error =
      corporateRepresentative.length <= corporateRepresentativeLengthLimit && corporateRepresentativeRegExp.test(corporateRepresentative)
          ? ""
          : corporateRepresentativeConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.corporateRepresentativeKana"(corporateRepresentativeKana: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["corporateRepresentativeKana"].error =
      corporateRepresentativeKana.length <= corporateRepresentativeKanaLengthLimit && corporateRepresentativeKanaRegExp.test(corporateRepresentativeKana)
          ? ""
          : corporateRepresentativeKanaConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.corporateName"(corporateName: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["corporateName"].error =
        corporateName.length <= corporateNameLengthLimit && corporateNameRegExp.test(corporateName)
          ? ""
          : corporateNameConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.corporateNameKana"(corporateNameKana: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["corporateNameKana"].error =
        corporateNameKana.length <= corporateNameKanaLengthLimit && corporateNameKanaRegExp.test(corporateNameKana)
          ? ""
          : corporateNameKanaConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.divisionName"(divisionName: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["divisionName"].error =
        divisionName.length <= divisionNameLengthLimit && divisionNameRegExp.test(divisionName)
          ? ""
          : divisionNameConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.contactMailAddress"(contactMailAddress: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["contactMailAddress"].error =
        contactMailAddress.length <= mailAddressLengthLimit && mailAddressRegExp.test(contactMailAddress)
          ? ""
          : mailAddressConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.phoneNumber"(phoneNumber: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["phoneNumber"].error =
        phoneNumber.length <= authPhoneNumberLengthLimit && authPhoneNumberRegExp.test(phoneNumber)
          ? ""
          : authPhoneNumberConstraintErrorMessage;
      this.afterWatch();
    },
    "corpInfoForm.fax"(fax: string) {
      this.beforeWatch();
      if (this.confirm) return;
      this.signupInputs["fax"].error =
      fax.length === 0 || (fax.length <= faxLengthLimit && faxRegExp.test(fax))
          ? ""
          : faxConstraintErrorMessage;
      this.afterWatch();
    },
  },
  computed: {
    /**
     * どれかエラーがあればdisabled
     */
     submitDisabled(): boolean {
      return (
              // エラーチェック
              this.signupInputs.corporateId.error.length > 0
              || this.signupInputs.corporateRepresentative.error.length > 0 
              || this.signupInputs.corporateRepresentativeKana.error.length > 0
              || this.signupInputs.corporateName.error.length > 0 
              || this.signupInputs.corporateNameKana.error.length > 0 
              || this.signupInputs.divisionName.error.length > 0 
              || this.signupInputs.contactMailAddress.error.length > 0
              || this.signupInputs.phoneNumber.error.length > 0 
              || this.signupInputs.fax.error.length > 0
              // 必須チェック
              || this.corpInfoForm.corporateId == null || this.corpInfoForm.corporateId == ''
              || this.corpInfoForm.corporateName == null || this.corpInfoForm.corporateName == ''
              || this.corpInfoForm.corporateNameKana == null || this.corpInfoForm.corporateNameKana == ''
              || this.corpInfoForm.corporateRepresentative == null || this.corpInfoForm.corporateRepresentative == ''
              || this.corpInfoForm.corporateRepresentativeKana == null || this.corpInfoForm.corporateRepresentativeKana == ''
              || this.corpInfoForm.contactMailAddress == null || this.corpInfoForm.contactMailAddress == ''
              || this.corpInfoForm.phoneNumber == null || this.corpInfoForm.phoneNumber == ''
             );
    },
  },
  data() {
    return {
      division: 0,
      readData: false,
      corpInfo: {} as CreateCorpInfoRequest,
      corpInfoForm: {} as CorpInfoForm,
      signupInputs: {
        corporateId: { name: '法人ID', type: 'text', placeholder: 'company123', class: '', required: true, constraint: corporateRepresentativeConstraintErrorMessage, error: '' },
        corporateName: { name: '法人名', type: 'text', placeholder: '株式会社レビューマーケッツ', class: '', required: true, constraint: corporateNameConstraintErrorMessage, error: '' },
        corporateNameKana: { name: '法人名カナ', type: 'text', placeholder: 'カブシキガイシャレビューマーケッツ', class: '', required: true, constraint: corporateNameKanaConstraintErrorMessage, error: '' },
        corporateRepresentative: { name: '法人管理者氏名', type: 'text', placeholder: '山田 太郎', class: '', required: true, constraint: corporateRepresentativeConstraintErrorMessage, error: '' },
        corporateRepresentativeKana: { name: '法人管理者カナ', type: 'text', placeholder: 'ヤマダ タロウ', class: '', required: true, constraint: corporateRepresentativeKanaConstraintErrorMessage, error: '' }, 
        divisionName: { name: '部署名', type: 'text', placeholder: 'システム開発事業部', class: '', required: false, constraint: divisionNameConstraintErrorMessage, error: '' },
        contactMailAddress: { name: '連絡先メール', type: 'text', placeholder: 'revma@example.com', class: '', required: true, constraint: mailAddressConstraintErrorMessage, error: '' },
        phoneNumber: { name: '電話番号', type: 'text', placeholder: '0123456789', class: 'half-column', required: true, constraint: authPhoneNumberConstraintErrorMessage, error: '' },
        fax: { name: 'FAX', type: 'text', placeholder: '0123456789', class: 'half-column', required: false,  constraint: faxConstraintErrorMessage, error: '' },
      },
      errorMessage: "",
      submitSuccess: false,
    };
  },
  methods: {
    async initData() {
      if (this.readData) {
        var storeCorpInfo = this.$store.getters.corpInfo as CorpInfo;
        this.corpInfo = JSON.parse(JSON.stringify(storeCorpInfo));
        this.corpInfoForm = JSON.parse(JSON.stringify(storeCorpInfo));
      }
    },
    format() {
      var form = this.corpInfoForm;
      // すべての項目の空白を除去
      Array.prototype.forEach.call(form, function (prop) {
        prop.trim();
      });
    },
    convertToForm() {
      this.corpInfoForm.corporateId = this.corpInfo.corporateId;
      this.corpInfoForm.managementUserId = this.corpInfo.managementUserId;
      this.corpInfoForm.corporateName = this.corpInfo.corporateName;
      this.corpInfoForm.corporateNameKana = this.corpInfo.corporateNameKana;
      this.corpInfoForm.divisionName = this.corpInfo.divisionName;
      this.corpInfoForm.corporateRepresentative = this.corpInfo.corporateRepresentative;
      this.corpInfoForm.corporateRepresentativeKana = this.corpInfo.corporateRepresentativeKana;
      this.corpInfoForm.contactMailAddress = this.corpInfo.contactMailAddress;
      this.corpInfoForm.phoneNumber = this.corpInfo.phoneNumber;
      this.corpInfoForm.fax = this.corpInfo.fax;
    },
    convertToModel() {
      this.corpInfo.corporateId = this.corpInfoForm.corporateId;
      this.corpInfo.managementUserId = this.corpInfoForm.managementUserId;
      this.corpInfo.corporateName = this.corpInfoForm.corporateName;
      this.corpInfo.corporateNameKana = this.corpInfoForm.corporateNameKana;
      this.corpInfo.divisionName = this.corpInfoForm.divisionName;
      this.corpInfo.corporateRepresentative = this.corpInfoForm.corporateRepresentative;
      this.corpInfo.corporateRepresentativeKana = this.corpInfoForm.corporateRepresentativeKana;
      this.corpInfo.contactMailAddress = this.corpInfoForm.contactMailAddress;
      this.corpInfo.phoneNumber = this.corpInfoForm.phoneNumber;
      this.corpInfo.fax = this.corpInfoForm.fax;
    },
    resetForm(corpInfoForm: CorpInfoForm) {
      this.corpInfoForm = corpInfoForm;
    },
    async submit() {
      this.convertToModel();
      try {
        var validation = this.validation();
        if (!validation.result) {
          this.$emit('errorToast', validation.message);
          return {res: false, data: {}};
        }
        this.format();
        this.corpInfo.managementUserId = this.$route.params.id;
        const res = await createCorpInfo(this.corpInfo);
        this.$store.dispatch('initCorpInfoForm');
        this.submitSuccess = true;

        return {res: true, data: res};
      } catch (e) {
        console.log(e);
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message == null) {
            this.$emit('errorToast', '法人情報の登録に失敗しました。しばらく経ってからやり直してください。');
          } else {
            this.$emit('errorToast', resError.message);
          }
        }
      }
    },
    validation() {
      this.convertToModel();

      var inputs = new Map(Object.entries(this.signupInputs));
      var form = new Map(Object.entries(this.corpInfo));
      var result = true;
      var error = false;

      // 任意項目以外の入力値があるとこを確認
      Map.prototype.forEach.call(inputs, function (value, key) {
        if (!error && value.contents) {
          Map.prototype.forEach.call(new Map(Object.entries(value.contents)), function (cValue, cKey) {
            if (!error && cValue.error.length <= 0) {
              if (result && cValue.required) {
                result = Boolean(form.get(cKey));
              }
            } else {
              error = true;
            }
          });
        } else {
          if (value.error <= 0) {
            if (result && value.required) {
              result = Boolean(form.get(key));
            }
          } else {
            error = true;
          }
        }
      });
      if (error) {
        return { result: false, message: "入力項目のエラーを解決してください。" };
      }

      if (!result) {
        return { result: result, message: "任意の項目以外は入力してください。" };
      }

      return { result: true, message: "" };
    },
    beforeWatch() {
      this.$emit("beforeWatch", this);
    },
    afterWatch() {
      this.submitDisabled;
      this.$emit("afterWatch", this);
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {}); // eslint-disable-line
      this.$emit('pushPath', path);
    },
  },
});
